import { render, staticRenderFns } from "./SaleList.vue?vue&type=template&id=2adc6794&scoped=true"
import script from "./SaleList.vue?vue&type=script&lang=js"
export * from "./SaleList.vue?vue&type=script&lang=js"
import style0 from "./SaleList.vue?vue&type=style&index=0&id=2adc6794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc6794",
  null
  
)

export default component.exports